/**
 * Spatial Bridge Utility
 * Re-exports the local spatialEventBus.
 */
import { spatialEventBus as bus } from '../spatial/spatialEventBus';

export const spatialEventBus = bus;
